









import { Component, Vue } from 'vue-property-decorator';

@Component<App>({ })
export default class App extends Vue {
  protected $pageTitle = '404';

  protected isLoading = true;
}
